import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function TermsAndConditions() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f7', fontFamily: 'Outfit, sans-serif' }}>

      {/* Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #ffcdd2', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 12, position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: '#d32f2f', display: 'flex', alignItems: 'center' }}>
          ←
        </button>
        <div>
          <div style={{ fontWeight: 800, fontSize: 17, color: '#1a1a2e' }}>📜 Terms & Conditions</div>
          <div style={{ fontSize: 11, color: '#888' }}>Last updated: 26 April 2026</div>
        </div>
      </div>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: '28px 20px 60px' }}>

        {/* Intro card */}
        <div style={{ background: '#fff', borderRadius: 16, padding: '22px 24px', marginBottom: 20, border: '1px solid #ffcdd2', boxShadow: '0 2px 12px rgba(211,47,47,0.07)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: 14, background: 'linear-gradient(135deg,#d32f2f,#e53935)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>📜</div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 20, color: '#1a1a2e' }}>Terms & Conditions</div>
              <div style={{ fontSize: 13, color: '#888' }}>HCEN — Healthcare Emergency Network</div>
            </div>
          </div>
          <p style={{ color: '#555', fontSize: 14, lineHeight: 1.75, margin: 0 }}>
            Please read these Terms & Conditions carefully. By using HCEN, you confirm that you have read, understood, and agree to be bound by these terms.
          </p>
        </div>

        {[
          {
            icon: '✋', title: '1. Acceptance of Terms',
            items: [
              'By registering or using HCEN, you confirm you are at least 18 years old (or have parental consent)',
              'You agree to these Terms and our Privacy Policy',
              'HCEN reserves the right to update these Terms at any time with notice to users',
            ]
          },
          {
            icon: '🏥', title: '2. About HCEN',
            items: [
              'HCEN is a healthcare technology platform connecting patients with hospitals',
              'HCEN is NOT a medical service provider — we are a technology intermediary',
              'All AI health guidance is for informational purposes only and does NOT replace professional medical consultation',
              'Always consult a licensed doctor for medical decisions',
            ]
          },
          {
            icon: '👤', title: '3. Patient Responsibilities',
            items: [
              'Provide accurate personal and health information',
              'Attend appointments you have booked on time',
              'Cancellation must be done at least 2 hours before appointment time',
              'Misuse of emergency alerts (false alarms) may result in account suspension',
              'Never share your OTP or account access with anyone',
            ]
          },
          {
            icon: '💊', title: '4. Hospital Services',
            items: [
              'HCEN connects you to registered hospitals — quality of medical care is the hospital\'s responsibility',
              'Consultation fees are set by individual hospitals, not HCEN',
              'Appointment availability depends on doctor schedule and hospital capacity',
              'HCEN does not guarantee specific wait times or treatment outcomes',
            ]
          },
          {
            icon: '💳', title: '5. Payments & Refunds',
            items: [
              'Payments are processed securely through Razorpay payment gateway (PCI-DSS Level 1 certified)',
              'Consultation fees are non-refundable once appointment is attended',
              'If hospital cancels: full refund within 5–7 business days',
              'Patient cancels 2+ hours before: full refund',
              'Patient cancels less than 2 hours before: no refund (cancellation fee applies)',
            ]
          },
          {
            icon: '🤖', title: '6. AI Health Features',
            items: [
              'Symptom checker, report analyser, and AI health chat are informational tools only',
              'These features do NOT provide medical diagnosis',
              'Never rely solely on AI guidance for health decisions — always see a doctor',
              'HCEN is not liable for any decisions made based solely on AI-generated content',
            ]
          },
          {
            icon: '🚨', title: '7. Emergency Services',
            items: [
              'The Emergency Alert connects you to registered hospitals only',
              'For life-threatening emergencies, ALWAYS call 108 (National Ambulance) first',
              'HCEN emergency alerts are not a substitute for government emergency services',
              'Intentional misuse of emergency alerts may lead to legal action',
            ]
          },
          {
            icon: '⚖️', title: '8. Limitation of Liability',
            items: [
              'HCEN is not liable for the quality or outcome of medical services by hospitals',
              'HCEN is not liable for technical issues caused by internet or device problems',
              'Maximum HCEN liability for any claim shall not exceed the amount paid for that service',
            ]
          },
          {
            icon: '🇮🇳', title: '9. Governing Law',
            items: [
              'These Terms are governed by the laws of India',
              'Any disputes shall be subject to the exclusive jurisdiction of courts in India',
            ]
          },
          {
            icon: '📞', title: '10. Contact',
            items: [
              'Email: legal@hcen.in',
              'HCEN Healthcare Pvt. Ltd., India',
            ]
          },
        ].map(section => (
          <div key={section.title} style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', marginBottom: 14, border: '1px solid #f0f0f0', boxShadow: '0 1px 6px rgba(0,0,0,0.04)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <span style={{ fontSize: 20 }}>{section.icon}</span>
              <span style={{ fontWeight: 700, fontSize: 15, color: '#d32f2f' }}>{section.title}</span>
            </div>
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {section.items.map((item, i) => (
                <li key={i} style={{ color: '#444', fontSize: 13.5, lineHeight: 1.7, marginBottom: 5 }}>{item}</li>
              ))}
            </ul>
          </div>
        ))}

        <div style={{ textAlign: 'center', marginTop: 28, fontSize: 12, color: '#aaa' }}>
          © {new Date().getFullYear()} HCEN Healthcare Pvt. Ltd. · <Link to="/privacy" style={{ color: '#d32f2f' }}>Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}
